/** Lowercase ASCII slug: "Râmnicu Vâlcea" / "râmnicu-vâlcea" -> "ramnicu-valcea". */
export function citySlug(value: string): string {
  let v = value;
  try {
    v = decodeURIComponent(value);
  } catch {
    /* keep raw */
  }
  return v
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
}
